let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6HQMp")).then(() => parcelRequire('040p3'));